module.exports = __webpack_public_path__ + "static/img/privacy-6.c3770be.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/privacy-6.png
// module id = R0bm
// module chunks = 1